///<reference path="../../App/plugins/DefinitelyTyped/google.maps.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { MySharedService } from '../App/shared.service';

@Component({
    templateUrl: './AppViews/Common/changePassword.html'
})

export class ChangePasswordComponent {
    //implements OnInit {


    constant: Constants;
    public passwordModel: any = {};
    userDetail: any;
    public showLoader = false;
    public isChangePasswordFormSubmitted = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.constant = new Constants();
        this.passwordModel = { 'UserId': this.userDetail.SiteUserId };
    }

    SavePassword(form: any) {
        this.isChangePasswordFormSubmitted = true;
        if (form.form.valid) {
            this.showLoader = true;
            this._httpService.ajaxPost("Login/ChangePassword", this.passwordModel).subscribe(
                data => {
                    this._sharedService.ShowMessage(data["Status"].Message);
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constant.globalError);
                },
                () => {
                    console.log("in completed");
                    this.showLoader = false;
                }
            );
        }
    }

    IspasswordMismatch() {
        if (Object.keys(this.passwordModel).length > 0 && this.passwordModel.NewPassword.length > 0 && this.passwordModel.Confirmpwd.length > 0) {
            if (this.passwordModel.NewPassword !== this.passwordModel.Confirmpwd) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/App/changePassword.component.ts
 **/